import _styled from "styled-components";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { getAccHostname } from '@adsk/acs-sc-web-platform-api';
import Illustration from '@adsk/alloy-react-illustration';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const TopBar = _ref => {
  let {
    className,
    style,
    children,
    hideLogo,
    admin
  } = _ref;
  const userHomeUrl = getAccHostname();
  const accLogo = /*#__PURE__*/React.createElement(Illustration, {
    style: _objectSpread({}, hideLogo && {
      visibility: 'hidden'
    }),
    type: Illustration.TYPES.ACC_HORIZONTAL_WHITE_NEW_2022
  });
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    "data-testid": "TopNavigation__TopBar",
    $_css: [{
      display: 'flex',
      alignItems: 'center',
      padding: '2px 10px',
      height: 24,
      background: admin ? theme.colors.charcoal700 : theme.colors.black
    }, style]
  }, !hideLogo && /*#__PURE__*/React.createElement("a", {
    "data-testid": "TopNavigation__TopBar__a",
    href: userHomeUrl
  }, accLogo), children);
};
TopBar.displayName = 'TopBar';
TopBar.propTypes = {
  /** TopBar's children */
  children: PropTypes.node,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** whether current view is external (login or public) */
  hideLogo: PropTypes.bool,
  /** whether current view is admin */
  admin: PropTypes.bool
};
export default TopBar;
var _StyledDiv = _styled("div").withConfig({
  displayName: "TopBar___StyledDiv",
  componentId: "sc-vku60c-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=TopBar.js.map